module.exports = __webpack_public_path__ + "static/img/active-button.9f3b5a4e.png";